import {Model} from '@vuex-orm/core';
import UserModel from "./userModel";

export default class ReportComment extends Model {

    static entity = 'report_comment';
    static primaryKey = 'id_report_comment';

    static fields() {
        return {
            id_report_comment: this.number(null),
            content: this.attr(null),
            created_at: this.attr(null),
            id_user: this.attr(null),
            user: this.belongsTo(UserModel, 'id_user', 'id_user'),
            id_report: this.number(null),

        };
    }
}